module.exports = __webpack_public_path__ + "static/media/hp-home-banner-mobile-@2x.f3b027cc.jpg";